/**
 * How the shell marks a widget's DOM so an event can be attributed to it. The dashboard
 * card carries both attributes (`dashboard-widget.tsx`). A slot widget (navigation, the
 * heading, access) renders without a wrapper element and counts as host-level for now.
 */
export const WIDGET_SCOPE_ATTRIBUTE = 'data-widget-scope';
export const WIDGET_INSTANCE_ATTRIBUTE = 'data-widget-instance-id';

export interface WidgetMarker {
  scope?: string;
  instanceId?: string;
}

/**
 * The widget an event happened in: the nearest marked element on the event's composed
 * path, which runs through open shadow roots. Empty for the host's own chrome and for
 * what UI kits render into `document.body` (modals, dropdowns), whose widget is unknown.
 */
export function widgetOf(path: readonly EventTarget[]): WidgetMarker {
  for (const node of path) {
    if (node instanceof Element && node.hasAttribute(WIDGET_SCOPE_ATTRIBUTE)) {
      const marker: WidgetMarker = {
        scope: node.getAttribute(WIDGET_SCOPE_ATTRIBUTE) ?? undefined
      };
      const instanceId = node.getAttribute(WIDGET_INSTANCE_ATTRIBUTE);
      if (instanceId) {
        marker.instanceId = instanceId;
      }
      return marker;
    }
  }
  return {};
}
